import styled, { css } from 'styled-components';
import UIAlert from 'UIComponents/alert/UIAlert';
import { GYPSUM } from 'HubStyleTokens/colors';
import useMDXLayout from 'developer-docs-shared-components/hooks/useMDXLayout';
import { mediaQueries, MOBILE_MENU_BREAKPOINT } from 'developer-docs-shared-components/utils/mediaQueries';
import GutterContainer from './GutterContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledAlert = styled(UIAlert).withConfig({
  displayName: "Alert__StyledAlert",
  componentId: "didesw-0"
})(["&&{padding:24px 32px;margin:16px 0;border:none;background:", ";p{&:last-child{margin-bottom:0;}}", "{font-size:inherit;}", "}"], ({
  type
}) => type === 'tip' ? GYPSUM : null, mediaQueries.aboveWidth(MOBILE_MENU_BREAKPOINT), () => {
  const isMDXLayout = useMDXLayout();
  return css(["", "{margin:", "px 0;}"], mediaQueries.aboveWidth(MOBILE_MENU_BREAKPOINT), isMDXLayout ? 32 : 8);
});

/**
 * Based on [UIAlert](https://tools.hubteamqa.com/ui-library/show/UIComponents/alert/UIAlert). Uses the same `type` to render as a different background
 * color, depending on its content.
 *
 * @see https://tools.hubteamqa.com/ui-library/show/UIComponents/alert/UIAlert
 */
const Alert = ({
  children,
  size = 'medium',
  type = 'info'
}) => /*#__PURE__*/_jsx(GutterContainer, {
  size: size,
  children: /*#__PURE__*/_jsx(StyledAlert, {
    type: type,
    children: children
  })
});
export default Alert;